import { CONTROL_SIZE } from "../common/public";
export var getWidthSize = function (size) {
    if (size === void 0) { size = CONTROL_SIZE.s; }
    return size || CONTROL_SIZE.full;
};
export function isItemsable(data) {
    return !!(data === null || data === void 0 ? void 0 : data.hasOwnProperty('items'));
}
//# sourceMappingURL=helpers.js.map